import {clsx} from 'clsx'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Link} from '@primer/react'
import type {Author} from '../commit-attribution-types'
import styles from './OrgLink.module.css'

/**
 * Renders the author of a commit.
 */
export function OrgLink({org, className}: {org: Author; className?: string}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const hovercardAttrs = getHovercardAttributesForType('organization', {login: org?.login ?? ''})

  if (!org) return null

  return (
    <div className={clsx('d-flex flex-row flex-items-center', className)}>
      <Link
        muted
        href={org.path}
        aria-label={`${org.login!}'s org home page`}
        {...hovercardAttrs}
        className={styles.orgLink}
      >
        {org.login!}
      </Link>
    </div>
  )
}
